// How wide should a tab strip's tabs be?
//
// The shared `Tabs` component defaults to MUI's `variant="fullWidth"`, which
// divides the available track into equal slices regardless of how much room the
// labels actually need. That is fine for two or three short labels. It stops
// being fine the moment a strip carries more than that inside a narrow side
// pane: MUI keeps dividing, the slices get smaller than the words, and every
// label clips.
//
// Measured live on web-stg (bundle `main.34fb621d.js`, 2026-07-31) in the Wheel
// Builder's Segment Settings pane (432px wide). The Wallpaper source strip
// carries seven tabs; each was laid out at 47.1px while its label needed more:
//
//   Colors 57 · Gradient 64 · Image 55 · SVG Patterns 63 · Loops 55 ·
//   Designs 61 · Preset Wallpapers 72        (scrollWidth vs 47px clientWidth)
//
// The four-tab colour-source strip below it clipped too ("Segment Palette",
// 80 vs 78). So the DEFAULT threshold is "more than three" — that is right
// for most strips.
//
// p12-wheel-palette-tab-label-cut-by-9px: the colour-source strip itself
// (Preset/Custom/Wheel Palette/Segment Palette) can ALSO land at exactly
// three tabs, whenever "Segment Palette" doesn't render (e.g. wheel 5914's
// fill picker) — "Wheel Palette" is long enough that a fullWidth three-way
// split still clips it (scrollWidth 103 vs clientWidth 91 in a 282px strip,
// measured live on web-dev.iyuga.net/builder/5914, bundle
// main.8c7b3af3.js) and this strip's tabs are not wired to shrink below
// their content width. So its two call sites (ColorPopup, SegmentColor)
// pass an explicit lower `threshold` of 2 instead of changing the shared
// default and affecting every other consumer.
//
// vy-0914-ew-seglib-chip-strip-clips-labels-icons: SegmentLibraryTabs' 3-tab
// Created/Cloned/Segment Sets strip (see tabs.js) used to deliberately stay
// fullWidth at exactly 3, on the theory that its short labels would compress
// instead of overflowing — that held for the label text (which does have
// minWidth:0 + ellipsis), but each tab also carries a fixed-size icon and
// count badge that don't shrink, so once fullWidth's equal division landed
// below that content's real width the excess got hard-clipped instead of
// ellipsized (icons cut mid-glyph, badge digits overlapping — MEASURED live
// web-dev main.56132db7.js 2026-09-14, /builder/6264). It now passes the
// same explicit lower `threshold` of 2 as the colour-source strip, for the
// same reason: this strip's tabs are not safely shrinkable below their real
// (icon + label + badge) content width.
//
// Above the threshold the strip becomes scrollable, which lets every tab keep
// its intrinsic width and gives the user scroll buttons to reach the rest.
// At or below it, nothing changes — the strip still divides the track exactly
// as it does today, so no existing two- or three-tab strip moves a pixel
// unless its call site opts into a lower threshold.
export const SCROLLABLE_TAB_THRESHOLD = 3;

export const tabsVariantFor = (categories, threshold = SCROLLABLE_TAB_THRESHOLD) =>
  Array.isArray(categories) && categories.length > threshold
    ? "scrollable"
    : "fullWidth";

export default tabsVariantFor;
